import React from 'react';
import DashboardShell from '../components/DashboardShell';
import LeadScoreApp from '../leadscore/LeadScoreApp';

/**
 * Lead Quality Score -- ported from the standalone project at
 * src/leadscore/ (see that folder's own files for the original component
 * tree). Mounted at /lead-quality-score/* in App.js; DashboardShell stays
 * the outer RUSH REPUBLIC / Log out bar (no Create account here, same as
 * the other placeholder pages), with the ported tool's own UI -- unchanged
 * from the standalone project, including its own breadcrumb nav -- as its
 * content.
 */
export default function LeadQualityScore() {
  return (
    <DashboardShell showCreateAccount={false}>
      <LeadScoreApp />
    </DashboardShell>
  );
}
